// extracted by mini-css-extract-plugin
export default {"root":"styles_root__-OGk+","checked":"styles_checked__voESb"};